// JSON-LD for the `gift` surface (`/gifts/[opaque_id]`).
//
// Schema choice: `Offer` (Product is for physical goods, Offer is for
// any thing being made available — fits a gifted token). Wrapped in a
// WebPage so search engines associate the offer with the page URL.

import type { ShareSurface } from '@/lib/share/events';

import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildGiftJsonLd(
  _surface: Extract<ShareSurface, { kind: 'gift' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const name = ctx.name ?? 'A Morfi gift';
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${ctx.pageUrl}#webpage`,
      url: ctx.pageUrl,
      name,
      ...(ctx.description !== undefined ? { description: ctx.description } : {}),
      primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
      isPartOf: { '@id': websiteId() },
      publisher: { '@id': organizationId() },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Offer',
      '@id': `${ctx.pageUrl}#offer`,
      name,
      url: ctx.pageUrl,
      image: ctx.ogImageUrl,
      offeredBy: { '@id': organizationId() },
      availability: 'https://schema.org/InStock',
      eligibleRegion: { '@type': 'Country', name: 'Worldwide' },
    },
  ];
}
